module.exports = __webpack_public_path__ + "img/join-background-3.12351678.png";